<template>
	<div>
		<div class="tw-text-3xl tw-font-bold" v-if="!isDone">
			{{ $t('integrations.enter-trendyol-details-title') }}
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold">
				{{ $t('integrations.thanks-for-submit-details') }}
			</div>
			<div
				class="'tw-border-secondary-500 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-secondary-500 tw-text-white"
				style="width: 32px; height: 32px"
			>
				<AppIcon name="check" />
			</div>
		</div>
		<div class="tw-font-medium tw-text-gray-500" v-if="!isDone">
			{{ $t('integrations.enter-trendyol-details-description') }}
		</div>
		<div class="tw-font-medium tw-text-gray-500" v-else>
			{{ $t('integrations.thanks-for-submit-trendyol-details-description') }}
		</div>
		<AppForm
			v-if="!isDone"
			class="tw-mt-3 tw-flex tw-flex-col tw-gap-4"
			style="width: 70%"
			@submit="onSubmit"
		>
			<div>
				<AppInput
					v-model="form.store_name"
					:label="$t('integrations.store-name')"
					:rules="['required']"
					:disabled="loading"
					:placeholder="$t('integrations.enter-store-name')"
				/>

				<AppInput
					v-model="form.supplier_id"
					:label="$t('integrations.supplier-id')"
					:rules="['required']"
					:disabled="loading"
				/>

				<AppInput
					v-model="form.api_key"
					:label="$t('integrations.api-key')"
					:rules="['required']"
					:disabled="loading"
				/>
				<AppInput
					v-model="form.api_secret_key"
					:label="$t('integrations.api-secret-key')"
					:rules="['required']"
					:disabled="loading"
				/>
				<AppCheckbox
					v-model="form.auto_integrate"
					class="tw-mt-2"
					:trueValue="1"
					:falseValue="0"
				>
					<template v-slot:label="{ toggle }">
						<div class="tw-flex tw-cursor-pointer tw-flex-col tw-ps-3" @click="toggle()">
							<div class="tw-text-lg tw-font-medium tw-text-gray-700">
								{{ $t('integrations.activate-auto-sync-products-orders') }}
							</div>
							<div class="tw-text-lg tw-text-gray-600">
								{{
									$t('integrations.select-to-sync-marketplace', {
										marketplace: marketplaceName,
									})
								}}
							</div>
						</div>
					</template>
				</AppCheckbox>
			</div>

			<div class="tw-mt-1">
				<AppButton
					:label="loading ? $t('integrations.authorizing') : $t('integrations.authorize')"
					size="xl"
					class="tw-rounded-full"
					type="submit"
					style="width: 250px"
					:disabled="loading"
				/>
			</div>
		</AppForm>
		<div class="tw-mt-3 tw-flex tw-items-center tw-gap-3" v-else>
			<AppButton
				:label="$t('integrations.next-step')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
				@click="nextStep"
				:loading="nextStepLoading"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { marketplaceStepStatusEnum } from '../../helper';

const linkMarketplaceStore = useLinkMarketplaceStore();

const form = ref({
	store_name: '',
	supplier_id: '',
	api_key: '',
	api_secret_key: '',
	auto_integrate: 1,
});

const loading = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.InProgress,
);
const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);
const nextStepLoading = ref(false);

const marketplaceName = computed(() => {
	return linkMarketplaceStore.marketplace.name || '';
});

const onSubmit = async () => {
	loading.value = true;
	try {
		const success = await Marketplace.setTrendyolDetails(form.value, linkMarketplaceStore.linkedMarketplaceId);
		if (!success) {
			document.location.href = '/store/subscribe/renew_package';
			return;
		}
		await linkMarketplaceStore.refetchSteps();
		isDone.value = true;
	} catch (err) {
		loading.value = false;
	}
};

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
